import {tenantModule} from "./tenantModule";
import {TenantService} from "./tenantService";
import {IAttributes, INgModelController, IScope} from "angular";
import jqXHR = JQuery.jqXHR;

class NlgTenantController {
    enabled = false
    tenantId = ""
    change: () => any

    constructor(private tenantService: TenantService) {
        "ngInject";
        tenantService.isNeedFill().then(enabled => this.enabled = enabled)
    }
}

tenantModule.directive("nlgTenant", function () {
    return {
        template: require("./nlgTenant.html"),
        controller: NlgTenantController,
        controllerAs: "ctrl",
        require: ["nlgTenant", "ngModel"],
        link($scope: IScope, $element: JQLite, $attrs: IAttributes, controllers: [NlgTenantController, INgModelController]) {
            let [nlgTenantController, ngModelController] = controllers
            ngModelController.$render = () => {
                nlgTenantController.tenantId = ngModelController.$viewValue
            }
            nlgTenantController.change = () => {
                ngModelController.$setViewValue(nlgTenantController.tenantId)
            }
        }
    }
})